"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _slatePlugins = require("@udecode/slate-plugins");
var _element = _interopRequireDefault(require("./element"));
var renderDiv = function renderDiv(options) {
  var _setDefaults = (0, _slatePlugins.setDefaults)(options, _element["default"]),
    div = _setDefaults.div;
  return (0, _slatePlugins.getRenderElement)(div);
};
var _default = exports["default"] = renderDiv;